export enum AlertType {
    Information = 0,
    Warning = 1,
    Danger = 2,
    Urgent = 3,
    Success = 4
}